module.exports = __webpack_public_path__ + "img/DW365-321.a5733bfa.jpg";